import { z } from "zod";

export const emailSchema = z
  .string({ error: "E-posta gerekli" })
  .trim()
  .toLowerCase()
  .pipe(z.email({ error: "Geçerli bir e-posta adresi girin" }).max(254));

export const passwordSchema = z
  .string({ error: "Şifre gerekli" })
  .min(12, { error: "Şifre en az 12 karakter olmalı" })
  .max(200, { error: "Şifre çok uzun" })
  .refine((v) => /[a-zçğıöşü]/.test(v) && /[A-ZÇĞİÖŞÜ]/.test(v) && /\d/.test(v), {
    error: "Şifre büyük harf, küçük harf ve rakam içermeli",
  });

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, { error: "Şifre gerekli" }).max(200),
  /** Beni hatırla: 30 günlük oturum. */
  remember: z.boolean().optional(),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({ email: emailSchema });
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    token: z.string().min(20).max(200),
    password: passwordSchema,
    passwordConfirm: z.string(),
  })
  .refine((v) => v.password === v.passwordConfirm, {
    error: "Şifreler eşleşmiyor",
    path: ["passwordConfirm"],
  });
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, { error: "Mevcut şifre gerekli" }).max(200),
    newPassword: passwordSchema,
    newPasswordConfirm: z.string(),
  })
  .refine((v) => v.newPassword === v.newPasswordConfirm, {
    error: "Şifreler eşleşmiyor",
    path: ["newPasswordConfirm"],
  })
  .refine((v) => v.newPassword !== v.currentPassword, {
    error: "Yeni şifre mevcut şifreyle aynı olamaz",
    path: ["newPassword"],
  });
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
